import React from 'react'

import styled from 'styled-components'


export const TextButton = styled.button`
  text-decoration: none;
  border-bottom: 1px solid;
  border-color: inherit;
  color: inherit;
  padding-bottom: 3px;
  font-size: 16px;
  border-top: none;
  border-left: none;
  border-right: none;
  ${props => props.variation === 'bold' && `
    font-weight: bold;
  ` }
  ${props => props.variation === 'gray' && `
    color: #C4C4C4;
  ` }
  ${props => props.variation === 'darkgray' && `
    color: #697376;
  ` }
`


export const StyledButton = styled.button`
  height: 3rem;
  width: 100%;
  max-width: ${props => props.isFullWidth === 'true' ? '100%' : '280px'};

  box-sizing: border-box;
  font-family: 'Source Sans Pro';
  line-height: 1.5rem;
  display: inline-block;

  padding-top: ${props => props.variation === 'fb' ? '8px' : '0.4375rem'};;
  padding-bottom: 0.5rem;
  padding-left: 32px;
  padding-right: 32px;

  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  font-weight: bold;
  font-size: 1rem;
  font-weight: bold;
  color:  ${props => props.variation === 'gold' ? '#232323' : props.variation === 'fb' ? '#fff' : '#fff'};
  background: ${props => props.variation === 'transparent' ? 'rgba(0, 0, 0, 0.3)' : props.variation === 'gold' ? '#F2C94C' : props.variation === 'fb' ? '#4267B2' : '#000'};
  box-sizing: border-box;
  border: 2px solid ${props => props.variation === 'gold' ? '#F2C94C' : props.variation === 'fb' ? '#4267B2' : '#fff'};
  user-select: none;

  transition: color 150ms ease-in-out, background-color 150ms ease-in-out;

  path
  {
    transition: fill 150ms ease-in-out;
  }

  &:hover {
    color: #000;
    background: #fff;
    path
    {
      fill: #000;
    }
  }

  &:focus
  {
    outline: none;
  }
  svg {
    vertical-align: middle;
    margin-top: -6px;
    margin-right: 8px;
  }
`


// WEBPACK FOOTER //
// ./src/components/Home/StyledButton.js